import { createApp } from "vue";
import App from "./App.vue";
import router from "./router"; // Import the router
import ElementPlus from "element-plus";
import store from "./store"; // Adjust the path according to your file structure
import { ElNotification, ElMessage } from 'element-plus';
import i18n from './i18n';

import apolloClient from "./services/apollo-client";
import { DefaultApolloClient } from "@vue/apollo-composable";

import { vMaska } from "maska";
import { phoneMaskDirective } from "./utils/phoneMask";

// import CSS
import "@fortawesome/fontawesome-free/css/all.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "element-plus/dist/index.css";
import "./main.css"; // Import our custom CSS after Element Plus

// import JS
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const app = createApp(App);

app.directive("maska", vMaska);
app.directive("phone-mask", phoneMaskDirective);

app.use(ElementPlus, {
  size: 'default',
  zIndex: 2000,
  message: {
    position: 'bottom-right'
  }
});

// Add notification configuration to the app instance
app.config.globalProperties.$notify = (options) => {
  return ElNotification({
    position: 'bottom-right',
    duration: 5000,
    offset: 80,
    customClass: 'custom-notification',
    ...options
  });
};

// Add message configuration to the app instance
app.config.globalProperties.$message = (options) => {
  return ElMessage({
    duration: 5000,
    ...options
  });
};


// -------------------------
import VueGoogleMaps from '@fawmi/vue-google-maps';

app.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_API_KEY,
    libraries: 'places', // important for autocomplete
  },
});

console.log("Google Maps loaded");
console.log("Google API Key: ", process.env.VUE_APP_GOOGLE_API_KEY);
// -------------------------


app.use(store);
app.use(router);
app.use(i18n);

app.provide(DefaultApolloClient, apolloClient);

// Make Apollo client available globally
window.apolloClient = apolloClient;

// Suppress ResizeObserver warnings
const resizeObserverErrHandler = (err) => {
  if (err.message && (
    err.message.includes('ResizeObserver') || 
    err.message.includes('ResizeObserver loop completed')
  )) {
    return;
  }
  console.error(err);
};

// Also handle unhandled promise rejections that might contain ResizeObserver errors
const unhandledRejectionHandler = (event) => {
  if (event.reason && typeof event.reason === 'string' && 
      event.reason.includes('ResizeObserver')) {
    event.preventDefault();
    return;
  }
};

window.addEventListener('error', resizeObserverErrHandler);
window.addEventListener('unhandledrejection', unhandledRejectionHandler);

// Override console.error to catch ResizeObserver errors
const originalConsoleError = console.error;
console.error = (...args) => {
  if (args[0] && typeof args[0] === 'string' && 
      args[0].includes('ResizeObserver loop completed')) {
    return;
  }
  originalConsoleError.apply(console, args);
};

app.mount("#app");
